import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Paper from '@material-ui/core/Paper';
import { DataGrid, ToolbarOptions } from 'tubular-react';
import { ColumnModel } from 'tubular-common';
import { styles } from './styles';
import { formatCurrency } from '../../../../utils/numberFormatter';

const columns = [
  new ColumnModel('Wallet', { Searchable: true }),
  new ColumnModel('Cash In', { Searchable: false }),
  new ColumnModel('Withdraw', { Searchable: false }),
  new ColumnModel('Partner Payment', { Searchable: false }),
  new ColumnModel('Without Disbursement', { Searchable: false })
];

const toolbarOptions = new ToolbarOptions({
  topPager: false,
  bottomPager: true
});

function SimpleTable(props) {
  const { classes } = props;
  const data = props.list.map(d => ({
    Wallet: d.wallet,
    'Cash In': formatCurrency(d.transaction_info.cash_in_amount || 0),
    Withdraw: formatCurrency(d.transaction_info.withdraw_amount || 0),
    'Partner Payment': formatCurrency(d.transaction_info.partner_payment),
    'Without Disbursement': formatCurrency(
      d.transaction_info.without_disbursment_amount
    )
  }));

  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title" className={classes.title}>
        Active Agent
      </DialogTitle>
      <DialogContent>
        <Paper className={classes.root}>
          <DataGrid
            columns={columns}
            dataSource={data}
            gridName="Distribution House"
            bottomPager={false}
            toolbarOptions={toolbarOptions}
          />
        </Paper>
      </DialogContent>
    </React.Fragment>
  );
}

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleTable);
